{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Отменить",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Интеграции",
    "DESCRIPTION": "Контакт-центр интегрируется с несколькими инструментами и сервисами, чтобы повысить эффективность вашей команды. Изучите список ниже, чтобы настроить ваши любимые приложения.",
    "LEARN_MORE": "Узнать больше об интеграциях",
    "LOADING": "Получение интеграций",
    "CAPTAIN": {
      "DISABLED": "Капитан не включен на вашем аккаунте.",
      "CLICK_HERE_TO_CONFIGURE": "Нажмите здесь, чтобы настроить",
      "LOADING_CONSOLE": "Загрузка консоли Капитана...",
      "FAILED_TO_LOAD_CONSOLE": "Не удалось загрузить консоль Капитана. Пожалуйста, обновите страницу и повторите попытку."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "События с подпиской",
      "LEARN_MORE": "Узнать больше о вебхуках",
      "FORM": {
        "CANCEL": "Отменить",
        "DESC": "Вебхуки позволяют получить вам информацию о том, что происходит в вашей учетной записи. Пожалуйста, введите корректный URL.",
        "SUBSCRIPTIONS": {
          "LABEL": "События",
          "EVENTS": {
            "INBOX_CREATED": "Источник создан",
            "CONVERSATION_CREATED": "Диалог создан",
            "CONVERSATION_STATUS_CHANGED": "Статус диалога изменён",
            "CONVERSATION_UPDATED": "Диалог обновлён",
            "MESSAGE_CREATED": "Сообщение создано",
            "MESSAGE_UPDATED": "Сообщение обновлено",
            "WEBWIDGET_TRIGGERED": "Виджет онлайн чата, открыт пользователем",
            "CONTACT_CREATED": "Контакт создан",
            "CONTACT_UPDATED": "Контакт обновлен",
            "JARABOT_EVENT": "Внутренние события"
          }
        },
        "END_POINT": {
          "LABEL": "URL вебхука",
          "PLACEHOLDER": "Пример: {webhookExampleURL}",
          "ERROR": "Пожалуйста, введите правильный URL"
        },
        "EDIT_SUBMIT": "Обновить webhook",
        "ADD_SUBMIT": "Создать вебхук"
      },
      "TITLE": "Вебхук",
      "CONFIGURE": "Настроить",
      "HEADER": "Настройки вебхуков",
      "HEADER_BTN_TXT": "Добавить новый вебхук",
      "LOADING": "Получение подключенных вебхуков",
      "SEARCH_404": "Нет вебхуков, соответствующих запросу",
      "SIDEBAR_TXT": "<p><b>Вебхуки</b> </p> <p>Вебхуки – это HTTP запросы, которые можно установить для любого аккаунта. Они вызываются по событиям: например, при создании новых сообщений. Вы можете создать сколько угодно вебхуков для этой учетной записи. <br /><br /> Для создания <b>вебхука</b>, нажмите на кнопку <b>Добавить новый вебхук</b>. Вы также можете удалить любой существующий вебхук, нажав на кнопку Удалить.</p>",
      "LIST": {
        "404": "У вас нет вебхуков.",
        "TITLE": "Управление вебхуками",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Адрес вебхука",
          "ACTIONS": "Действия"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Редактировать",
        "TITLE": "Редактировать вебхук",
        "API": {
          "SUCCESS_MESSAGE": "Конфигурация вебхука успешно обновлена",
          "ERROR_MESSAGE": "Не удается соединиться с сервером Woot, попробуйте позже"
        }
      },
      "ADD": {
        "CANCEL": "Отменить",
        "TITLE": "Добавить новый вебхук",
        "API": {
          "SUCCESS_MESSAGE": "Конфигурация вебхука успешно добавлена",
          "ERROR_MESSAGE": "Не удается соединиться с сервером Woot, попробуйте позже"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Удалить",
        "API": {
          "SUCCESS_MESSAGE": "Вебхук удален",
          "ERROR_MESSAGE": "Не удается соединиться с сервером Woot, попробуйте позже"
        },
        "CONFIRM": {
          "TITLE": "Подтвердите удаление",
          "MESSAGE": "Вы уверены, что хотите удалить вебхук? ({webhookURL})",
          "YES": "Да, удалить ",
          "NO": "Нет, не удалять"
        }
      },
      "DISABLED_BADGE": "Выключено",
      "DISABLED_REASON": "Автоматически отключён после {count} последовательных ошибок. Последняя ошибка: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "Включить",
        "API": {
          "SUCCESS_MESSAGE": "Вебхук успешно включён",
          "ERROR_MESSAGE": "Не удалось включить вебхук, попробуйте позже"
        }
      }
    },
    "SLACK": {
      "DELETE": "Удалить",
      "DELETE_CONFIRMATION": {
        "TITLE": "Удалить интеграцию",
        "MESSAGE": "Вы уверены, что хотите удалить интеграцию? Это приведет к потере доступа к диалогам на вашем рабочем пространстве."
      },
      "HELP_TEXT": {
        "TITLE": "Как использовать интеграцию Slack?",
        "BODY": "С этой интеграцией, все входящие диалоги будут синхронизированы с **{selectedChannelName}*** каналом в вашей рабочей области Slack. Вы можете управлять переписками клиентов прямо на канале и никогда не пропускать сообщения.\n\nВот основные особенности интеграции:\n\n**Ответить на диалоги из Slack:** Чтобы ответить на разговор в ***{selectedChannelName}*** канале Slack, просто напечатайте ваше сообщение и отправьте его. Это создаст ответ клиенту через контакт-центр. Это так просто!\n\n **Создавайте личные заметки:** Если вы хотите создавать личные заметки вместо ответов, начните свое сообщение с ***`note:`***. Это гарантирует, что ваше сообщение будет приватным и не будет видно клиенту.\n\n**Связать профиль агента:** Если человек, ответивший в Slack имеет профиль агента в контакт-центре с такой же электронной почтой, ответы будут автоматически связаны с профилем этого агента. Это означает, что вы легко можете отслеживать кто, когда и что ответил,. С другой стороны, если у отвечающего нет соответствующего профиля агента, ответы отправятся клиенту от имени бота.",
        "SELECTED": "выбрано"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Выбрать канал",
        "UPDATE": "Обновить",
        "BUTTON_TEXT": "Подключить канал",
        "DESCRIPTION": "Рабочая область Slack теперь связана с контакт-центром. Однако интеграция в настоящее время неактивна. Чтобы активировать интеграцию и подключить канал к чату, нажмите на кнопку ниже.\n\n**Примечание:** Если вы пытаетесь подключить частный канал, добавьте наше приложение в канал Slack перед тем как приступить к этому шагу.",
        "ATTENTION_REQUIRED": "Требуется внимание",
        "EXPIRED": "Ваша интеграция в Slack истекла. Чтобы продолжить получение сообщений в Slack, удалите интеграцию и подключите рабочую область снова."
      },
      "UPDATE_ERROR": "Произошла ошибка при обновлении интеграции, пожалуйста, попробуйте еще раз",
      "UPDATE_SUCCESS": "Канал успешно подключен",
      "FAILED_TO_FETCH_CHANNELS": "Произошла ошибка при получении каналов из Slack, попробуйте еще раз"
    },
    "OPEN_AI": {
      "AI_ASSIST": "Помощь ИИ",
      "WITH_AI": " {option} с ИИ ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Предложить ответ",
        "SUMMARIZE": "Подведем итог",
        "REPHRASE": "Улучшить написание",
        "FIX_SPELLING_GRAMMAR": "Исправить правописание и грамматику",
        "SHORTEN": "Сократить",
        "EXPAND": "Развернуть",
        "MAKE_FRIENDLY": "Изменить тон сообщения на дружеский",
        "MAKE_FORMAL": "Использовать официальный тон",
        "SIMPLIFY": "Упростить",
        "TRANSLATE": "Перевести",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "Перевести на основной язык"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Содержание черновика",
        "GENERATED_TITLE": "Генерированное содержимое",
        "AI_WRITING": "ИИ пишет",
        "BUTTONS": {
          "APPLY": "Использовать этот вариант перевода",
          "CANCEL": "Отменить"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Интеграция с OpenAI",
        "DESC": "Принесите дополнительные функции AI на вашу панель управления с помощью моделей GPT OpenAI. Чтобы начать, введите API ключ из вашей учетной записи OpenAI.",
        "KEY_PLACEHOLDER": "Введите ваш OpenAI API ключ",
        "BUTTONS": {
          "NEED_HELP": "Нужна помощь?",
          "DISMISS": "Отклонить",
          "FINISH": "Завершить установку"
        },
        "DISMISS_MESSAGE": "Вы можете настроить интеграцию OpenAI позже, когда хотите.",
        "SUCCESS_MESSAGE": "Интеграция OpenAI успешно настроена"
      },
      "TITLE": "Улучшить с ИИ",
      "SUMMARY_TITLE": "Сводка с ИИ",
      "REPLY_TITLE": "Ответить с помощью ИИ",
      "SUBTITLE": "Улучшенный ответ будет создан с помощью AI, основанный на текущем проекте.",
      "TONE": {
        "TITLE": "Тон",
        "OPTIONS": {
          "PROFESSIONAL": "Профессиональный",
          "FRIENDLY": "Дружелюбный"
        }
      },
      "BUTTONS": {
        "GENERATE": "Создать",
        "GENERATING": "Создание...",
        "CANCEL": "Отменить"
      },
      "GENERATE_ERROR": "При сохранении настроек произошла ошибка, пожалуйста, попробуйте еще раз"
    },
    "DELETE": {
      "BUTTON_TEXT": "Удалить",
      "API": {
        "SUCCESS_MESSAGE": "Интеграция удалена"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Подключить"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Панель приложений",
      "HEADER_BTN_TXT": "Добавить новое приложение",
      "SIDEBAR_TXT": "<p><b>Панель приложений</b></p><p>Панель приложений, позволяют организациям встраивать приложение в панель управления, чтобы предоставлять контекст для агентов службы поддержки клиентов. Эта функция позволяет вам создать приложение независимо и встроить его в панель инструментов для предоставления информации о пользователях, их заказах или их предыдущей истории платежей.</p><p>Когда вы встраиваете свое приложение в панель управления, ваше приложение будет получать контекст разговора и связей событий. Реализуйте связи для события сообщения на своей странице, чтобы получать контекст.</p><p>Чтобы добавить новое приложение панели приложений, нажмите кнопку \"Добавить приложение\".</p>",
      "DESCRIPTION": "Панель приложений, позволяют организациям встраивать приложение внутри панели управления для обеспечения контекста агентов по поддержке клиентов. Эта функция позволяет создать приложение независимо и встраивать информацию о пользователе, его заказах или их истории платежей.",
      "LEARN_MORE": "Подробнее об интеграциях",
      "LIST": {
        "404": "В этой панели приложений не настроено ни одной интеграции",
        "LOADING": "Загрузка приложений...",
        "TABLE_HEADER": {
          "NAME": "Имя",
          "ENDPOINT": "Endpoint"
        },
        "EDIT_TOOLTIP": "Редактировать приложение",
        "DELETE_TOOLTIP": "Удалить приложение"
      },
      "FORM": {
        "TITLE_LABEL": "Имя",
        "TITLE_PLACEHOLDER": "Введите имя для вашего приложения",
        "TITLE_ERROR": "Требуется название для панели приложений",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Введите URL-адрес конечной точки, где размещено приложение",
        "URL_ERROR": "Требуется действительный URL"
      },
      "CREATE": {
        "HEADER": "Добавить новое приложение",
        "FORM_SUBMIT": "Отправить",
        "FORM_CANCEL": "Отменить",
        "API_SUCCESS": "Приложение панели инструментов успешно настроено",
        "API_ERROR": "Не удалось обновить настройки входящих сообщений. Пожалуйста, повторите попытку позже"
      },
      "UPDATE": {
        "HEADER": "Редактировать приложение",
        "FORM_SUBMIT": "Обновить",
        "FORM_CANCEL": "Отменить",
        "API_SUCCESS": "Приложение панели инструментов успешно обновлено",
        "API_ERROR": "Не удалось обновить приложение. Повторите попытку позже"
      },
      "DELETE": {
        "CONFIRM_YES": "Да, удалить",
        "CONFIRM_NO": "Нет, не удалять",
        "TITLE": "Подтвердите удаление",
        "MESSAGE": "Вы уверены, что хотите удалить приложение - {appName}?",
        "API_SUCCESS": "Приложение успешно удалено",
        "API_ERROR": "Не удалось удалить приложение. Повторите попытку позже"
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Создать/Связать Задачу",
      "LOADING": "Загрузка связанных задач...",
      "LOADING_ERROR": "Ошибка получения данных о связанных задачах, пожалуйста попробуйте еще раз",
      "CREATE": "Создать",
      "LINK": {
        "SEARCH": "Поиск задач",
        "SELECT": "Выбрать задачу",
        "TITLE": "Ссылка",
        "EMPTY_LIST": "Связанных проблем не найдено",
        "LOADING": "Загрузка",
        "ERROR": "Ошибка получения данных о связанных задачах, пожалуйста попробуйте еще раз",
        "LINK_SUCCESS": "Связывание задачи прошло успешно",
        "LINK_ERROR": "При привязке этой задачи произошла проблема",
        "LINK_TITLE": "Диалог (#{conversationId}) с {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Создать/Привязать задачу из linear",
        "DESCRIPTION": "Создать задачу из linear из сообщения или привязать существующую задачу",
        "FORM": {
          "TITLE": {
            "LABEL": "Название",
            "PLACEHOLDER": "Введите название",
            "REQUIRED_ERROR": "Необходимо указать название"
          },
          "DESCRIPTION": {
            "LABEL": "Описание",
            "PLACEHOLDER": "Введите описание"
          },
          "TEAM": {
            "LABEL": "Команда",
            "PLACEHOLDER": "Выберите команду",
            "SEARCH": "Найти команду",
            "REQUIRED_ERROR": "Требуется команда"
          },
          "ASSIGNEE": {
            "LABEL": "Назначено",
            "PLACEHOLDER": "Выбрать ответственного",
            "SEARCH": "Поиск ответственного"
          },
          "PRIORITY": {
            "LABEL": "Приоритет",
            "PLACEHOLDER": "Выберите приоритет",
            "SEARCH": "Приоритет поиска"
          },
          "LABEL": {
            "LABEL": "Метка",
            "PLACEHOLDER": "Выбрать метку",
            "SEARCH": "Поиск меток"
          },
          "STATUS": {
            "LABEL": "Статус",
            "PLACEHOLDER": "Выбрать статус",
            "SEARCH": "Статус поиска"
          },
          "PROJECT": {
            "LABEL": "Проект",
            "PLACEHOLDER": "Выбрать проект",
            "SEARCH": "Поиск проекта"
          }
        },
        "CREATE": "Создать",
        "CANCEL": "Отменить",
        "CREATE_SUCCESS": "Проблема успешно создана",
        "CREATE_ERROR": "Произошла ошибка при создании проблемы, пожалуйста, попробуйте еще раз",
        "LOADING_TEAM_ERROR": "Ошибка получения данных о связанных задачах, пожалуйста попробуйте еще раз",
        "LOADING_TEAM_ENTITIES_ERROR": "Произошла ошибка при получении элементов команды, попробуйте еще раз"
      },
      "ISSUE": {
        "STATUS": "Статус",
        "PRIORITY": "Приоритет",
        "ASSIGNEE": "Назначено",
        "LABELS": "Категории",
        "CREATED_AT": "Создано {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Отвязать",
        "SUCCESS": "Задача успешно отвязана",
        "ERROR": "Произошла ошибка при отвязке задачи, пожалуйста, попробуйте ещё раз"
      },
      "DELETE": {
        "TITLE": "Вы уверены, что хотите удалить интеграцию?",
        "MESSAGE": "Вы уверены, что хотите удалить интеграцию?",
        "CONFIRM": "Да, удалить",
        "CANCEL": "Отменить"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Капитан",
    "HEADER_KNOW_MORE": "Know more",
    "COPILOT": {
      "SEND_MESSAGE": "Отправить сообщение...",
      "EMPTY_MESSAGE": "Произошла ошибка при генерации ответа. Пожалуйста, попробуйте ещё раз.",
      "LOADER": "Капитан думает",
      "YOU": "Вы",
      "USE": "Использовать это",
      "RESET": "Сброс",
      "SELECT_ASSISTANT": "Выбрать ассистента"
    },
    "PAYWALL": {
      "TITLE": "Обновите тарифный план, чтобы использовать Captain AI",
      "AVAILABLE_ON": "Капитан недоступен на бесплатном тарифном плане.",
      "UPGRADE_PROMPT": "Обновите тарифный план, чтобы получить доступ к нашим ассистентам, copilot и другим функциям.",
      "UPGRADE_NOW": "Обновить сейчас",
      "CANCEL_ANYTIME": "Вы можете изменить или отменить ваш тарифный план в любое время"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Функция Captain AI доступна только в платном плане.",
      "UPGRADE_PROMPT": "Обновите тарифный план, чтобы получить доступ к нашим ассистентам, copilot и другим функциям.",
      "ASK_ADMIN": "Пожалуйста, обратитесь к вашему администратору для обновления."
    },
    "BANNER": {
      "RESPONSES": "Вы использовали более 80% лимита ответов. Чтобы продолжить использование Captain AI, пожалуйста, обновите тариф.",
      "DOCUMENTS": "Достигнут лимит документов. Обновите тарифный план, чтобы продолжить использование Captain AI."
    },
    "FORM": {
      "CANCEL": "Отменить",
      "CREATE": "Создать",
      "EDIT": "Обновить"
    },
    "ASSISTANTS": {
      "HEADER": "Ассистенты",
      "ADD_NEW": "Создать нового ассистента",
      "DELETE": {
        "TITLE": "Вы уверены, что хотите удалить ассистента?",
        "DESCRIPTION": "Это действие необратимо. Удаление этого ассистента удалит его из всех подключенных источников и навсегда удалит все сгенерированные знания.",
        "CONFIRM": "Да, удалить",
        "SUCCESS_MESSAGE": "Ассистент успешно удален",
        "ERROR_MESSAGE": "При удалении ассистента произошла ошибка. Пожалуйста, попробуйте еще раз."
      },
      "FORM_DESCRIPTION": "Заполните приведенные ниже сведения, чтобы назвать своего ассистента, описать его цель и указать поддерживаемый продукт.",
      "CREATE": {
        "TITLE": "Создать ассистента",
        "SUCCESS_MESSAGE": "Ассистент успешно создан",
        "ERROR_MESSAGE": "При создании ассистента произошла ошибка, пожалуйста, попробуйте еще раз."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Имя ассистента",
          "PLACEHOLDER": "Введите имя ассистента",
          "ERROR": "Пожалуйста, укажите имя ассистента"
        },
        "DESCRIPTION": {
          "LABEL": "Описание ассистента",
          "PLACEHOLDER": "Опишите, как и где будет использоваться этот ассистент",
          "ERROR": "Необходимо описание"
        },
        "PRODUCT_NAME": {
          "LABEL": "Название продукта",
          "PLACEHOLDER": "Введите название продукта, для которого предназначен этот ассистент",
          "ERROR": "Требуется название продукта"
        },
        "FEATURES": {
          "TITLE": "Возможности",
          "ALLOW_CONVERSATION_FAQS": "Создать FAQ из решённых диалогов",
          "ALLOW_MEMORIES": "Сохраняйте ключевые детали в виде воспоминаний о взаимодействии с клиентами."
        }
      },
      "EDIT": {
        "TITLE": "Обновить ассистента",
        "SUCCESS_MESSAGE": "Ассистент успешно обновлен",
        "ERROR_MESSAGE": "При обновлении ассистента произошла ошибка, пожалуйста, попробуйте еще раз."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Редактировать ассистента",
        "DELETE_ASSISTANT": "Удалить ассистента",
        "VIEW_CONNECTED_INBOXES": "Просмотр подключенных источников"
      },
      "EMPTY_STATE": {
        "TITLE": "Нет доступных ассистентов",
        "SUBTITLE": "Создайте ассистента, чтобы дать быстрые и точные ответы пользователям. Он может учиться на ваших статьях из центра поддержки и прошлых диалогах.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Документы",
      "ADD_NEW": "Создать новый документ",
      "RELATED_RESPONSES": {
        "TITLE": "Связанные FAQ",
        "DESCRIPTION": "Эти FAQ генерируются напрямую из документа."
      },
      "FORM_DESCRIPTION": "Введите URL документа, чтобы добавить его в качестве источника знаний и выберите ассистента, с которым он свяжется.",
      "CREATE": {
        "TITLE": "Добавить документ",
        "SUCCESS_MESSAGE": "Документ успешно создан",
        "ERROR_MESSAGE": "Произошла ошибка при создании документа, пожалуйста, попробуйте еще раз."
      },
      "FORM": {
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Введите URL документа",
          "ERROR": "Пожалуйста, укажите корректный URL для документа"
        },
        "ASSISTANT": {
          "LABEL": "Ассистент",
          "PLACEHOLDER": "Выберите ассистента",
          "ERROR": "Необходимо заполнить поле ассистента"
        }
      },
      "DELETE": {
        "TITLE": "Вы уверены, что хотите удалить этот документ?",
        "DESCRIPTION": "Это действие необратимо. Удаление этого документа навсегда удалит все сгенерированные знания.",
        "CONFIRM": "Да, удалить",
        "SUCCESS_MESSAGE": "Документ успешно удалён",
        "ERROR_MESSAGE": "При удалении документа произошла ошибка, пожалуйста, попробуйте еще раз."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "Просмотр связанных ответов",
        "DELETE_DOCUMENT": "Удалить документ"
      },
      "EMPTY_STATE": {
        "TITLE": "Нет доступных документов",
        "SUBTITLE": "Документы используются Вашим ассистентом для создания FAQ. Вы можете импортировать документы для предоставления контекста для Вашего ассистента.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "FAQ",
      "ADD_NEW": "Создать новый FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Диалог #{id}"
      },
      "SELECTED": "Выбрано {count}",
      "BULK_APPROVE_BUTTON": "Одобрить",
      "BULK_DELETE_BUTTON": "Удалить",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQ успешно одобрены",
        "ERROR_MESSAGE": "Произошла ошибка при одобрении FAQ, пожалуйста, попробуйте ещё раз."
      },
      "BULK_DELETE": {
        "TITLE": "Удалить FAQ?",
        "DESCRIPTION": "Вы уверены, что хотите удалить выбранные FAQ? Это действие невозможно отменить.",
        "CONFIRM": "Да, удалить всё",
        "SUCCESS_MESSAGE": "FAQ успешно удалены",
        "ERROR_MESSAGE": "Произошла ошибка при удалении FAQ, пожалуйста, попробуйте ещё раз."
      },
      "DELETE": {
        "TITLE": "Вы действительно хотите удалить FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Да, удалить",
        "SUCCESS_MESSAGE": "FAQ успешно удален",
        "ERROR_MESSAGE": "Произошла ошибка при удалении FAQ, попробуйте еще раз."
      },
      "FILTER": {
        "ASSISTANT": "Ассистент: {selected}",
        "STATUS": "Статус: {selected}",
        "ALL_ASSISTANTS": "Все"
      },
      "STATUS": {
        "TITLE": "Статус",
        "PENDING": "В ожидании",
        "APPROVED": "Одобрено",
        "ALL": "Все"
      },
      "FORM_DESCRIPTION": "Добавьте вопрос и соответствующий ему ответ в базу знаний и выберите ассистента, с которым он должен связаться.",
      "CREATE": {
        "TITLE": "Добавить FAQ",
        "SUCCESS_MESSAGE": "Ответ успешно добавлен.",
        "ERROR_MESSAGE": "При добавлении ответа произошла ошибка. Пожалуйста, попробуйте еще раз."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Вопрос",
          "PLACEHOLDER": "Введите вопрос",
          "ERROR": "Пожалуйста, введите корректный вопрос."
        },
        "ANSWER": {
          "LABEL": "Ответ",
          "PLACEHOLDER": "Введите ответ",
          "ERROR": "Пожалуйста, введите корректный ответ."
        },
        "ASSISTANT": {
          "LABEL": "Ассистент",
          "PLACEHOLDER": "Выбрать ассистента",
          "ERROR": "Выбрать ассистента"
        }
      },
      "EDIT": {
        "TITLE": "Обновить FAQ",
        "SUCCESS_MESSAGE": "FAQ успешно обновлён",
        "ERROR_MESSAGE": "Произошла ошибка при обновлении FAQ, пожалуйста, попробуйте ещё раз",
        "APPROVE_SUCCESS_MESSAGE": "FAQ был отмечен как одобренный"
      },
      "OPTIONS": {
        "APPROVE": "Отметить как одобренный",
        "EDIT_RESPONSE": "FAQ отмечен как одобренный",
        "DELETE_RESPONSE": "Удалить FAQ"
      },
      "EMPTY_STATE": {
        "TITLE": "FAQ не найдены",
        "SUBTITLE": "FAQ помогают вашему ассистенту быстро и точно отвечать на вопросы клиентов. Их можно генерировать автоматически из вашего контента или добавлять вручную.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Подключённые источники входящих",
      "ADD_NEW": "Подключить новый источник входящих",
      "OPTIONS": {
        "DISCONNECT": "Отключиться"
      },
      "DELETE": {
        "TITLE": "Вы уверены, что хотите отключить этот источник входящих?",
        "DESCRIPTION": "",
        "CONFIRM": "Да, удалить",
        "SUCCESS_MESSAGE": "Источник входящих успешно отключён.",
        "ERROR_MESSAGE": "Произошла ошибка при отключении источника входящих, пожалуйста, попробуйте ещё раз."
      },
      "FORM_DESCRIPTION": "Выберите источник входящих для подключения к ассистенту.",
      "CREATE": {
        "TITLE": "Подключить источник входящих",
        "SUCCESS_MESSAGE": "Источник входящих успешно подключён.",
        "ERROR_MESSAGE": "Произошла ошибка при подключении источника входящих. Пожалуйста, попробуйте ещё раз."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Электронная почта",
          "PLACEHOLDER": "Выберите источник входящих для развертывания ассистента.",
          "ERROR": "Необходимо выбрать источник входящих."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "Нет подключённых источников входящих",
        "SUBTITLE": "Подключение источника входящих позволяет ассистенту обрабатывать первые вопросы ваших клиентов до их передачи вам."
      }
    }
  }
}
